import React, { Component } from 'react';
import { observer } from 'mobx-react';
import store from '../store/store.js'

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';


const Menu = observer((props) => {
  console.log('isRefresh ', store.isRefresh);
  return (
  <IconMenu
    //{...props}
    iconButtonElement={
      <IconButton><MoreVertIcon color="white" /></IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
    { store.isRefresh
      ? <MenuItem primaryText="Обновить" onClick={store.refresh} /> 
      : null }
    <MenuItem primaryText="Выход" onClick={props.logout} />
  </IconMenu>
  )}
);

export default Menu;


// WEBPACK FOOTER //
// ./src/coms/Menu.jsx